import { Suspense } from "react";
import {
  filterProductsByIds,
  filterProductsBySkus
} from "../../utils/ProductsUtils";
import ProductGrid from "../ProductGrid";
import { useUserProducts } from "../../hooks/ProductHooks";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import SimpleLoadingSpinner from "../SimpleLoadingSpinner";

const CockpitProductGridInner = ({
  id,
  className = "",
  style,
  skus,
  ids,
  layout = "card",
  showCartButtons = false
}) => {
  const t = useBjelinTranslations();
  const products = useUserProducts();
  const filteredProducts =
    ids && ids.length > 0
      ? filterProductsByIds(products, ids)
      : filterProductsBySkus(products, skus);
  const cols = filteredProducts.length > 3 ? 4 : 3;

  return filteredProducts.length > 0 ? (
    <div id={id} className={className} style={{ ...style, minHeight: "90px" }}>
      <ProductGrid
        products={filteredProducts}
        cols={cols}
        layout={layout}
        showCartButtons={showCartButtons}
        className={className}
      />
    </div>
  ) : (
    <div className="empty-msg">
      <div>
        <Icon name="face-sad-tear" size="4x" />
      </div>
      <div>{t("product.carousel.isempty")}</div>
    </div>
  );
};

const CockpitProductGrid = props => {
  return (
    <Suspense
      fallback={
        <div className="center-content" aria-busy>
          <SimpleLoadingSpinner />
        </div>
      }
    >
      <CockpitProductGridInner {...props} />
    </Suspense>
  );
};

export default CockpitProductGrid;
